import React, { useEffect, useState } from 'react';
import Tooltip from 'react-simple-tooltip';

import axios from 'axios';
import { useAccount } from 'wagmi';

import { useGlobalContext } from '../../AppContext';
import { notify } from '../../utils/utils';
import { BigMenu } from '../../components/BigMenu';
import { Button } from '../../components/Button';

import './Settings.scss';

export const Settings = () => {
  const { config, hideMinimumWallet, hideMinimumToken } = useGlobalContext();
  const [minimumWalletAmount, setMinimumWalletAmount] = useState<number>(hideMinimumWallet || 0);
  const [minimumTokenAmount, setMinimumTokenAmount] = useState<number>(hideMinimumToken || 0);
  const { address: account } = useAccount();
  const [redirect, setRedirect] = useState<boolean>(false);

  // use effect
  useEffect(() => {
    if (redirect) {
      setTimeout(() => {
        document.location.reload();
      }, 1000);
    }
  }, [redirect]);

  const updateMinimumAmount = async (type: string, amount: number): Promise<void> => {
    try {
      const response = await axios({
        url: `${process.env.REACT_APP_API}/update-hide-amounts.php`,
        params: {
          type: type === 'wallet' ? 'wallet' : 'token',
          amount: amount,
        },
        headers: { 'Content-Type': 'application/json' },
        withCredentials: true,
      });

      if (response && response.data && response.data.code === 0) {
        setRedirect(true);
      } else if (response && response.data && response.data.data) {
        notify('There is an error, please try again later.');
      }
    } catch (error) {}
  };

  return (
    <div className="settings">
      <BigMenu horizontal={true} />
      {redirect && (
        <div className="redirect-info">Wallets are rearranged according to the changes...</div>
      )}
      {config && (
        <div className={`mt-5`}>
          <div className="row">
            <div
              className={`data-container ${account ? '' : 'blur'} ${redirect ? 'blurred' : ''}`}
              onClick={() => {
                if (!account) {
                  notify('You need to connect your wallet to use this feature.');
                }
              }}
            >
              <div className="item">
                Minimum wallet balance{' '}
                <Tooltip
                  placement="bottom"
                  className="tooltip"
                  border="#ff6aff"
                  background="var(--color-background-main)" 
                  color="var(--color-text-main)"
                  content={'You can filter your portfolio wallets by balance.'}
                >
                  <div className="question-circle">?</div>
                </Tooltip>
              </div>
              <div className="description">
                Hide wallets which is lower than:{' '}
                <input
                  disabled={account ? false : true}
                  type="number"
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    const value = Number(e.currentTarget.value);
                    setMinimumWalletAmount(Number.isNaN(value) ? 0 : value);
                  }}
                  value={minimumWalletAmount}
                />
                <Button
                  color="two"
                  size="large"
                  icon="check"
                  onClick={() => {
                    if (account) {
                      updateMinimumAmount('wallet', minimumWalletAmount);
                    }
                  }}
                />
              </div>
            </div>

            <div
              className={`data-container ${account ? '' : 'blur'} ${redirect ? 'blurred' : ''}`}
              onClick={() => {
                if (!account) {
                  notify('You need to connect your wallet to use this feature.');
                }
              }}
            >
              <div className="item">
                Minimum token price{' '}
                <Tooltip
                  placement="bottom"
                  className="tooltip"
                  border="#ff6aff"
                  background="var(--color-background-main)" 
                  color="var(--color-text-main)"
                  content={'You can filter your tokens by price.'}
                >
                  <div className="question-circle">?</div>
                </Tooltip>
              </div>
              <div className="description">
                Hide tokens which is lower than:{' '}
                <input
                  disabled={account ? false : true}
                  type="number"
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    const value = Number(e.currentTarget.value);
                    setMinimumTokenAmount(Number.isNaN(value) ? 0 : value);
                  }}
                  value={minimumTokenAmount}
                />
                <Button
                  color="two"
                  size="large"
                  icon="check"
                  onClick={() => {
                    if (account) {
                      updateMinimumAmount('token', minimumWalletAmount);
                    }
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
